import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-collapse-accordion',
  templateUrl: './collapse-accordion.component.html',
  styleUrls: ['./collapse-accordion.component.scss']
})

export class CollapseAccordionComponent implements OnInit {

  @ViewChild('oilPrice') sectionreference

  iivFund: Array<Object>

  @Input() collapseIIV: any

  @Input() date: string

  @Input() time: string

  caretStatus: string
  constructor() {

  }

  ngOnInit() {
  }

  linkStoxx() {
    location.href = 'https://www.stoxx.com/index-details?symbol=SXAE3DGV&stoxxindex=sxae3dgv&searchTerm=stoxx+asean+select+dividend';
  }
  isPositive(value) {
    if (Math.sign(value) === 1) {
      this.caretStatus = 'up'
      return true
    } else if (Math.sign(value) === -1 || Math.sign(value) === 0) {
      this.caretStatus = 'down'
      return false
    }
  }

  showOnlyValue(value) {
    return Math.abs(value)
  }

  isCheckcolor(value) {

    if (value > 0) {

      return 'green'

    } else {
      return 'red'
    }
  }
}
